import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { Phone, EnvelopeSimple, BuildingOffice, WhatsappLogo } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Contact() {
  const [tracking, setTracking] = useState(null);
  useEffect(() => {
    api.get("/tracking/aruba").then((r) => setTracking(r.data)).catch(() => {});
  }, []);

  const submit = (e) => {
    e.preventDefault();
    // Intentional MVP: no lead form persistence — spec channels leads via phone.
    toast.success("Thanks — we received your note. For a booking, please call the Aruba line.");
    e.currentTarget.reset();
  };

  return (
    <div className="bg-cream min-h-screen">
      <Nav />
      <section className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-20 grid md:grid-cols-2 gap-16">
        <div>
          <div className="text-[11px] uppercase tracking-[0.35em] text-teal mb-6">— Contact</div>
          <h1 className="font-display text-5xl sm:text-6xl text-navy leading-[0.95]">
            Talk with <em className="text-gold not-italic">LocalRida.</em>
          </h1>
          <p className="mt-6 text-navy/70 max-w-md leading-relaxed">
            For a booking, the fastest path is always the phone or WhatsApp — hotels, resorts, vacation
            rentals, and San Nicolas alike. For operator partnerships, press coverage, or a hotel-concierge
            arrangement, send us a note.
          </p>

          <div className="mt-12 space-y-8">
            {tracking && (
              <>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.28em] text-navy/50 mb-1">Aruba direct line — call now</div>
                  <a href={`tel:${tracking.number_e164}`} className="font-display text-3xl text-navy hover:text-gold transition-colors inline-flex items-center gap-3" data-testid="contact-phone">
                    <Phone size={24} weight="thin" />
                    {tracking.display}
                  </a>
                  <div className="text-xs text-navy/60 mt-1">A driver confirmed in minutes.</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.28em] text-navy/50 mb-1">WhatsApp — quick reply, no app needed</div>
                  <a
                    href={`https://wa.me/${(tracking.whatsapp_e164 || tracking.number_e164).replace(/[^\d]/g, "")}?text=${encodeURIComponent("Hi LocalRida — I'd like to book a private transfer in Aruba.")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-whatsapp"
                    className="font-display text-3xl text-navy hover:text-teal transition-colors inline-flex items-center gap-3"
                  >
                    <WhatsappLogo size={24} weight="thin" />
                    {tracking.whatsapp_display || tracking.display}
                  </a>
                  <div className="text-xs text-navy/60 mt-1">Works on airport &amp; hotel WiFi.</div>
                </div>
              </>
            )}
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-navy/50 mb-1">General</div>
              <div className="font-display text-2xl text-navy inline-flex items-center gap-3">
                <EnvelopeSimple size={20} weight="thin" />
                hello@localrida.com
              </div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-navy/50 mb-1">Operator partnerships</div>
              <div className="font-display text-2xl text-navy inline-flex items-center gap-3">
                <BuildingOffice size={20} weight="thin" />
                partners@localrida.com
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="border border-cream2 p-10 bg-cream space-y-6" data-testid="contact-form">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.28em] text-navy/60 mb-2">Name</label>
            <input required data-testid="contact-name" name="name" className="w-full border-b border-navy/20 bg-transparent py-3 focus:outline-none focus:border-gold text-navy" />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.28em] text-navy/60 mb-2">Email</label>
            <input required type="email" data-testid="contact-email" name="email" className="w-full border-b border-navy/20 bg-transparent py-3 focus:outline-none focus:border-gold text-navy" />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.28em] text-navy/60 mb-2">Message</label>
            <textarea required rows={5} data-testid="contact-message" name="message" className="w-full border-b border-navy/20 bg-transparent py-3 focus:outline-none focus:border-gold text-navy resize-none" />
          </div>
          <button
            type="submit"
            data-testid="contact-submit"
            className="w-full bg-navy text-cream py-4 text-xs uppercase tracking-[0.28em] hover:bg-gold hover:text-navy transition-colors"
          >
            Send Note
          </button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
